import React from 'react';
import { Brain, Zap, Target, Dumbbell } from 'lucide-react';
export function TrainingMethod() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#223322]" data-id="element-133">
      <div className="max-w-5xl mx-auto text-center" data-id="element-134">
        <div className="inline-flex items-center justify-center p-4 bg-green-900/30 rounded-full mb-8" data-id="element-135">
          <Brain className="w-12 h-12 text-[#c8e6c9]" data-id="element-136" />
        </div>

        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-12 text-[#faf5e8]" data-id="element-137">
          No entrenás partes.
          <br data-id="element-138" />
          <span className="text-[#c8e6c9]" data-id="element-139">Entrenás el TODO:</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-140">
          <div className="bg-[#1a2e1a] p-8 rounded-2xl border border-green-800/50 hover:border-[#c8e6c9]/50 transition-colors" data-id="element-141">
            <Zap className="w-10 h-10 text-[#c8e6c9] mx-auto mb-4" data-id="element-142" />
            <h3 className="font-heading text-2xl font-bold mb-2 text-[#faf5e8]" data-id="element-143">
              Velocidad
            </h3>
            <p className="text-xl text-[#a8c5a8] font-medium" data-id="element-144">+ decisión</p>
          </div>

          <div className="bg-[#1a2e1a] p-8 rounded-2xl border border-green-800/50 hover:border-[#c8e6c9]/50 transition-colors" data-id="element-145">
            <Target className="w-10 h-10 text-[#c8e6c9] mx-auto mb-4" data-id="element-146" />
            <h3 className="font-heading text-2xl font-bold mb-2 text-[#faf5e8]" data-id="element-147">
              Técnica
            </h3>
            <p className="text-xl text-[#a8c5a8] font-medium" data-id="element-148">+ presión</p>
          </div>

          <div className="bg-[#1a2e1a] p-8 rounded-2xl border border-green-800/50 hover:border-[#c8e6c9]/50 transition-colors" data-id="element-149">
            <Dumbbell className="w-10 h-10 text-[#c8e6c9] mx-auto mb-4" data-id="element-150" />
            <h3 className="font-heading text-2xl font-bold mb-2 text-[#faf5e8]" data-id="element-151">
              Físico
            </h3>
            <p className="text-xl text-[#a8c5a8] font-medium" data-id="element-152">
              + contexto real
            </p>
          </div>
        </div>
      </div>
    </section>;
}